import { Component, OnInit, ViewChild } from '@angular/core';
import { DELETEHISTORY } from '../common/constants/labels';
import { IncidentUploadSqlService } from '../incident-upload-SQL/incident-upload-sql.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-delete-history',
  templateUrl: './delete-history.component.html',
  styleUrls: ['./delete-history.component.scss']
})
export class DeleteHistoryComponent implements OnInit {
title = 'Delete History';
deleteHistoryColumn = DELETEHISTORY;
loading = false;
noRecords = '';
noRecordsShow = false;
showErrorMessage = false;
errorMsg = '';
// dataSource = [];
@ViewChild('paginator', {static: false}) paginator!: MatPaginator;
dataSource!: MatTableDataSource<any>;

  constructor(private incidentservice: IncidentUploadSqlService) { }

  ngOnInit() {
    this.loading = true;
    this.getDeleteHistory();
  }

  getDeleteHistory() {
    this.incidentservice.getDeleteHistoryData().subscribe((response) => {
      this.noRecordsShow = false;
      if (response.length > 0) {
        const deletedRecords = [];
        response.forEach((e) => {
          let object = {};
          object = {
            filenames: e.filenames,
            recordcount: e.recordcount,
            deleteddate: e.deleteddate,
            deletedby: e.deletedby
          };
          deletedRecords.push(object);
        });
        // this.dataSource = deletedRecords;
        this.dataSource = new MatTableDataSource(deletedRecords);
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      } else {
        this.noRecords = 'No Records available';
        this.noRecordsShow = true;
        this.loading = false;
      }
    }, (error) => {
      this.noRecordsShow = true;
      this.errorMsg = 'Failed to get the deleted history.';
      this.showErrorMessage = true;
      this.loading = false;
    });
  }

}
